import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface Theme {
  id: string;
  name: string;
  themeOptions: Record<string, any>;
  isDefault: boolean;
}

export interface QprThemeProviderState {
  themes: Theme[];
  error?: ErrorObject;
}

const initialState = {
  themes: []
} as QprThemeProviderState;

export default initialState;
